<template>
  <vx-card>
    <div class="px-5">
      <vx-card class="mt-base" title="Refund Policy" no-shadow card-border>
        <div>
          <template>
          <ul class="ml-8 pb-8">
            <li class="p-2"><p>
              The transaction status is final and the merchant is obligated to
              deliver the goods/services or to update your payment in a timely
              manner. You should contact the merchant for the delivery of your
              goods/services purchased. You can provide the necessary details
              such as the online receipt issued by the merchant or the email
              notification received contain the following details:
              </p>
              <ol class="ml-12 p-1">
                <li class="list-item-component">Transaction ID</li>
                <li>Merchant Order No.</li>
                <li>Payment amount</li>
                <li>Date and time of the payment</li>
                </ol>
            </li>
            <li class="p-2">
              It is not possible to cancel the transaction via the system.
              However, you can write in to us for any discrepancy and for such
              cancellation is subject to the merchant’s policy.
            </li>

            <li class="p-2">
              Please remind when you proceed with the transaction, do double
              check the transactions is correct before you proceed with the
              payment.
            </li>

            <li class="p-2">
              All successful payment considers good and non-refundable as the
              payment processed is the end of the services provided and agreed
              during the payment process.
            </li>
          </ul>
          </template>
        </div>
      </vx-card>
    </div>
  </vx-card>
</template>
<script>
import List from '@/views/components/vuesax/list/List'
export default {
  components: { List },
}
</script>
<style scoped>
ol li {
  list-style-type: decimal;
}

ul {
  list-style-type: square;
}

</style>
